import * as actionTypes from './actionTypes'
import { Record } from 'immutable'

const UpdateState = Record({
  ongoing: false,
  success: false,
  error: null,
})

const State = Record(
  {
    fetchMyOrganizationContacts: {},
  },
  'ContactUser'
)

const ContactUserReducer = (state = new State(), { type, payload }) => {
  switch (type) {
    case actionTypes.FETCH_MY_ORGANIZATION_CONTACTS_START: {
      return state.setIn(
        ['fetchMyOrganizationContacts'],
        new UpdateState({ ongoing: true })
      )
    }

    case actionTypes.FETCH_MY_ORGANIZATION_CONTACTS_SUCCESS: {
      return state.setIn(
        ['fetchMyOrganizationContacts'],
        new UpdateState({ success: true })
      )
    }

    case actionTypes.FETCH_MY_ORGANIZATION_CONTACTS_ERROR: {
      return state.setIn(
        ['fetchMyOrganizationContacts'],
        new UpdateState({ error: payload })
      )
    }

    default: {
      return state
    }
  }
}

export default ContactUserReducer
